import request from "../../utils/request";
import { Result } from "../../models/general";

// Role categories + review settings for the Team Role Management settings page (Q1 Role-Clarity).

export interface BusinessRoleCategory {
  id: number;
  name: string;
  isActive: boolean;
}

export interface BusinessRoleCategoryInput {
  id?: number;
  name: string;
  isActive: boolean;
}

export interface BusinessRoleSettings {
  reviewIntervalMonths: number;
}

// Categories

export async function getCategories(): Promise<Result<BusinessRoleCategory[]>> {
  const response = await request.get<Result<BusinessRoleCategory[]>>("BusinessRoleCategory/GetCategories");
  return response.data;
}

export async function addCategory(input: BusinessRoleCategoryInput): Promise<Result<BusinessRoleCategory>> {
  const response = await request.post<Result<BusinessRoleCategory>>("BusinessRoleCategory/AddCategory", input);
  return response.data;
}

export async function updateCategory(input: BusinessRoleCategoryInput): Promise<Result<BusinessRoleCategory>> {
  const response = await request.put<Result<BusinessRoleCategory>>("BusinessRoleCategory/UpdateCategory", input);
  return response.data;
}

export async function deleteCategory(id: number): Promise<Result<boolean>> {
  const response = await request.delete<Result<boolean>>(`BusinessRoleCategory/DeleteCategory/${id}`);
  return response.data;
}

// Review settings

export async function getRoleReviewSettings(): Promise<Result<BusinessRoleSettings>> {
  const response = await request.get<Result<BusinessRoleSettings>>("BusinessRoleSettings/GetSettings");
  return response.data;
}

export async function updateRoleReviewSettings(input: BusinessRoleSettings): Promise<Result<BusinessRoleSettings>> {
  const response = await request.put<Result<BusinessRoleSettings>>("BusinessRoleSettings/UpdateSettings", input);
  return response.data;
}
